"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlertTypeViewItems = void 0;
const getAlertType_1 = require("./../../../View/Alert/Utilities/getAlertType");
const getAlertTypeViewItems = (alert) => {
    const alertType = (0, getAlertType_1.getAlertType)(alert);
    const text = (0, getAlertType_1.getAlertTypeText)(alertType);
    return {
        name: 'Type',
        values: [text],
    };
};
exports.getAlertTypeViewItems = getAlertTypeViewItems;
